module.exports = function(app) {
    app.value('eprSpouseValidationHelper', {forms: []});
	app.directive('eprDependent', [function() {
		return {
			restrict: 'A',
			replace: false,
            template: require('directives/employee/eprDependent.html'),

            scope: {
                dependent: '=eprDependent',
                employee: '=?employee',
				validationSuffix: '=?',
				editMode: '=?',
                onEditPage: '=?'
			},

			controller: ['$scope', 'services', 'options', 'addFlowCommander','employee', 'eprSpouseValidationHelper', 'sessionData',
				function($scope, services, options, addFlowCommander, employee, eprSpouseValidationHelper, sessionData) {
                    $scope.onEditPage = $scope.onEditPage ? $scope.onEditPage : null;

					$scope.commander = addFlowCommander;
                    $scope.dt1900 = new Date(1900, 0, 1);
                    $scope.dtBirthmin = {
                        'minB': $scope.dt1900,
                    };

					services.eprsvc.enrollmentsPrefixesAndRelationships().fetch().then(

						function(response) {

                            $scope.relationships = response.relationships;
							$scope.prefixes = response.prefixes;
						}
					);
                    $scope.specialstatusdata = [];
                    services.eprsvc.enrollmentsSpecialStatusValues().fetch().then(
                        function(response) {
                            if (Array.isArray(response)){
                                $scope.specialstatusdataMap = {};
                                response.forEach(function(obj) {
                                    $scope.specialstatusdataMap[obj.label] = obj.label;
                                    $scope.specialstatusdata.push(obj);
                                });
                            }
                        }
                    );
					$scope.suffixes = options.suffixes;

                    $scope.dependentHasAnyActiveLobs = function() {
                        var anyActiveLobs = false;
                        var today = new Date();
                        if (Array.isArray($scope.dependent.memberCoverages)) {
                            $scope.dependent.memberCoverages.forEach(function(coverage) {
                                if (Array.isArray(coverage.memberLobs)) {
                                    coverage.memberLobs.forEach(function(lob) {
                                        if (!lob.coverageEndDate || lob.coverageEndDate > today) {
                                            anyActiveLobs = true;
                                        }
                                    });
                                }
                            });
                        }
                        return anyActiveLobs;
                    };

                    $scope.relationshipCodeToName = function(strRelCode) {
                        // relationship.value as relationship.label for relationship in relationships
                        var strRetval = '';
                        angular.forEach($scope.relationships, function(rel){
                            if (rel.value == strRelCode) {
                                strRetval = rel.label;
                            }
                        });

                        return strRetval;
                    };

					$scope.today = new Date();
                    $scope.today.setDate($scope.today.getDate() + 1);

                    function calculateAge(birthday) {
                        if (birthday && birthday instanceof Date) {
                            var ageDifMs = Date.now() - birthday.getTime();
                            var ageDate = new Date(ageDifMs);
                            return Math.abs(ageDate.getUTCFullYear() - 1970);
                        }
                        else { return 100; }
                    }

                    $scope.ageOver26 = function (birthDate) {
                        return calculateAge(birthDate) >= 26;
                    };

                    eprSpouseValidationHelper.forms.splice(0,999); // empty forms array without breaking the reference
                    $scope.initRelationship = function(dependentForm) {
                        eprSpouseValidationHelper.forms.push(dependentForm); // add form to array
                    };

                    // Relationship Changes
                    $scope.relationshipConditions = function(dependent, dependentForm) {





// errors here




                        eprSpouseValidationHelper.forms.forEach(function(form) { // loop thru froms array
                            form.depRelationship.$validate(); // validate an input on the form
                        });
                        //If Spouse (01) or Age is > 26 then, set specialStatus to null and disable it (ng-disable on html)

                        if (((dependent.relationship === 'SPOUSE') ||(dependent.relationshipCode === '01')||(dependent.relationshipCode === '29')) || $scope.ageOver26(dependent.birthDate)) {
                            dependent.dependentStatus = '';
                        }

                        /* IF 'Special Status' = Full Time Student - MNLOA
                         THEN 'Relationship to Employee' MUST be one of the following:
                         �         Son or Daughter 02
                         �         Grandchild 05
                         �         Nephew or Niece 07
                         �         Adopted 09ss
                         �         Brother or Sister 14
                         �         Stepson or Stepdaughter 17
                         AND the MNLOA tab should display in the left nav when the Actor clicks 'Save & Continue' on the Subscriber & Participants page
                         */


                        if (['02', '05', '07', '9', '14', '17'].indexOf(dependent.relationshipCode) >= 0) {
                            $scope.showMNLOA = true;
                        }
                        else {
                            $scope.showMNLOA = false;
                            if (dependent.dependentStatus === 'M') {
                                dependent.dependentStatus = '';
                            }
                        }
                    };

                    $scope.showMNLOA = (['02', '05', '07', '9', '14', '17'].indexOf($scope.dependent.relationshipCode) >= 0);


				}
			]
		};
	}]);
};
